export const YEAR_FORMAT = "YYYY";
export const MONTH_FORMAT = "MMMM";
export const DAY_SIZE = 40;
export const WEEK_FIRST_DAY = 1;
